import React from 'react';

import { ErrorMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';

import useText from '@hooks/use-text';

export const CouldNotFetchProductSpendingLimits = () => {
    const { productSpendingLimitFetchError } = useText();
    return <ErrorMessage text={productSpendingLimitFetchError} icon={IconTypes.LUKK_24} />;
};
